export default {
    mounted() {
        this.setHeaderData(
            this.header.back,
            this.header.title,
            this.header.backLink,
            this.header.remove,
        )
    },
}